import { Box, Divider, Typography } from '@mui/material'
import "@fontsource/rubik";
import { formatHistoryDateTime } from '../../../utils/revisionHistory'
import RevisionHistoryNotes from './RevisionHistoryNotes'
import RevisionHistoryTimeline from './RevisionHistoryTimeline'
import RevisionVersionActions from './RevisionVersionActions'

/**
 * Detail panel for the selected version in the standalone history popup: player,
 * share link, download, notes and timeline. Download / share rules live in
 * RevisionVersionActions, shared with the in-card history panel.
 *
 * `video_url: null` means the file is still transferring after delivery, so the
 * player is replaced with a processing message rather than a broken one.
 */
const RevisionHistoryVersionDetail = (props) => {
  const { version, notesVisible } = props;

  if (!version) return null;

  return (
    <Box textAlign='left' sx={{ width: '100%' }}>
      <Box className='flex a-center' gap={2} sx={{ justifyContent: 'space-between', flexWrap: 'wrap', mb: 1 }}>
        <Box>
          <Typography
            sx={{ fontFamily: 'Rubik', fontWeight: 600, color: 'black', fontSize: { xs: '11px', md: '13px', lg: '14px', xl: '20px' } }}
          >
            Version {version?.version}
          </Typography>
          <Typography
            sx={{ fontFamily: 'Rubik', color: '#08231B', opacity: 0.75, fontSize: { xs: '7px', md: '9px', lg: '9px', xl: '12px' } }}
          >
            Delivered {formatHistoryDateTime(version?.delivered_at)}
          </Typography>
        </Box>

        <RevisionVersionActions version={version} />
      </Box>

      {version?.video_url ? (
        <video
          key={version?.final_video_id}
          data-testid='revision-history-player'
          src={version.video_url}
          controls
          controlsList='nodownload'
          style={{ width: '100%', maxHeight: '340px', borderRadius: '8px', backgroundColor: '#000000' }}
        />
      ) : (
        <Box
          data-testid='revision-history-processing'
          className='flex j-center a-center'
          sx={{ width: '100%', height: { xs: '120px', lg: '180px', xl: '240px' }, borderRadius: '8px', backgroundColor: '#f2f2f2' }}
        >
          <Typography sx={{ fontFamily: 'Rubik', color: '#08231B', fontSize: { xs: '9px', md: '11px', lg: '12px', xl: '16px' } }}>
            Video is processing
          </Typography>
        </Box>
      )}

      {!!version?.filename && (
        <Typography
          sx={{ fontFamily: 'Rubik', color: '#08231B', opacity: 0.7, wordBreak: 'break-all', fontSize: { xs: '7px', md: '9px', lg: '9px', xl: '12px' }, mt: 0.6 }}
        >
          {version.filename}
        </Typography>
      )}

      {/* The notes panel is hidden entirely - not emptied - without Notes -> View. */}
      {notesVisible && (
        <>
          <Divider sx={{ my: 2 }} />
          <RevisionHistoryNotes revision={version?.revision} />
        </>
      )}

      <Divider sx={{ my: 2 }} />
      <RevisionHistoryTimeline timeline={version?.timeline} version={version?.version} />
    </Box>
  )
}

export default RevisionHistoryVersionDetail
